var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconModal2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F5F8FD",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3062D4",
    fillRule: "evenodd",
    d: "M15.2 10.4h8.4a3.6 3.6 0 0 1 3.6 3.6v5.571c0 .33-.313.569-.638.515a6.5 6.5 0 0 0-7.129 8.75c.136.355-.11.764-.488.764H15.2a3.6 3.6 0 0 1-3.6-3.6V14a3.6 3.6 0 0 1 3.6-3.6ZM14 14a1 1 0 0 1 1-1h8.5a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2H15Zm-1 5a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3062D4",
    d: "M22.293 25.907a1 1 0 0 0-.293.707V28a1 1 0 0 0 1 1h1.386a1 1 0 0 0 .707-.293l3.2-3.2a1 1 0 0 0 0-1.414l-1.386-1.386a1 1 0 0 0-1.414 0l-3.2 3.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconModal2);
export default __webpack_public_path__ + "static/media/edit-icon-modal-2.fb3a8638b21c872155671cdf50f42013.svg";
export { ForwardRef as ReactComponent };